import React from 'react';

export default
<g id="icon/view/vertical" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <rect id="Rectangle" stroke="#D8D8D8" strokeWidth="2" x="1" y="1" width="34" height="34" rx="2"></rect>
    <g id="Group" transform="translate(18.000000, 18.000000) rotate(-90.000000) translate(-18.000000, -18.000000) translate(8.000000, 8.000000)" fill="#D8D8D8">
        <rect id="Rectangle" x="8" y="0" width="4" height="20" rx="1"></rect>
        <rect id="Rectangle" x="16" y="0" width="4" height="20" rx="1"></rect>
        <rect id="Rectangle" x="0" y="0" width="4" height="20" rx="1"></rect>
    </g>
</g>
